export default __webpack_public_path__ + "img/PosterWaterfall4ColCropped.2b191562.png";